import { ILineFare, ILineFareInfo } from "@/domain/entities/lineInfo";
import TYPES from "@/ioc/identifiers";
import { ILineInfoRepository } from "@/repositories/lineInfo/lineInfoRepository.types";
import { BookIntervalCode } from "@/types";
import { inject, injectable } from "inversify";
import { ILineFareUseCase } from "./interface/ILineFareUseCase";
import { IResultData } from "@/domain/entities/shared/result";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";

@injectable()
export class LineFareUseCase implements ILineFareUseCase {
  private lineRepository: ILineInfoRepository;

  constructor(
    @inject(TYPES.ILineInfoRepository) lineRepository: ILineInfoRepository
  ) {
    this.lineRepository = lineRepository;
  }

  async getLineFare(turnId: string): Promise<IResultData<ILineFare>> {
    const lineFareResult: IResultData<ILineFare> = {
      isSuccess: false,
    };

    await this.lineRepository
      .getLineFares(turnId)
      .then((result) => {
        result
          .map((lineFares) => {
            lineFareResult.isSuccess = true;
            lineFareResult.data = {
              dailyFare: this.getFare(lineFares, BookIntervalCode.DAY),
              monthlyFare: this.getFare(lineFares, BookIntervalCode.MONTH),
            };
          })
          .mapErr((error) => {
            useSetResultCodeIfNeeded(lineFareResult, error);
            lineFareResult.errorMessage = error.message;
          });
      })
      .catch((error) => {
        lineFareResult.errorMessage = error.message;
      });

    return lineFareResult;
  }

  private getFare = (
    lineFares: ILineFareInfo[],
    bookIntervalCode: BookIntervalCode
  ) => {
    return lineFares.find((fare) => fare.bookIntervalCode === bookIntervalCode)
      ?.fareAmount;
  };
}
